import React, { useState } from 'react';
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';

const PdfMerge=(props)=>{
    const [uploadPdfFromDesk, setuploadPdfFromDesk]=useState({
        pdf1:'',
        pdf2:''
    })
    const mergePdfDocu=async ()=>{
        if(uploadPdfFromDesk.pdf1&&uploadPdfFromDesk.pdf2){
            const mergedPdf = await PDFDocument.create();
    
            const pdfA = await PDFDocument.load(uploadPdfFromDesk.pdf1);
            const pdfB = await PDFDocument.load(uploadPdfFromDesk.pdf2);
    
            const copiedPagesA = await mergedPdf.copyPages(pdfA, pdfA.getPageIndices());
            copiedPagesA.forEach((page) => mergedPdf.addPage(page));
    
            const copiedPagesB = await mergedPdf.copyPages(pdfB, pdfB.getPageIndices());
            copiedPagesB.forEach((page) => mergedPdf.addPage(page));
    
            const mergedPdfFile = await mergedPdf.saveAsBase64();
            props.getmergedocsData(mergedPdfFile)
        }else{
            console.log('please upload file to merge')
        }

    }
    return(
        <div style={{
            display:'flex'
        }}>
            <div>
                <div>
                    <label>upload from system</label>
                </div>
                <input type='file' accept="application/pdf" onChange={(ev)=>{
                    let file=ev.target.files[0]
                    if(file!==undefined){
                    console.log(file)
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        // setfiledata(e.target.result)
                        // console.log(e.target.result)
                        setuploadPdfFromDesk({...uploadPdfFromDesk, pdf1:e.target.result})
                    }
                    reader.readAsDataURL(file);
                    }
                }}/>
            </div>
            <div>
                <div>
                    <label>Upload from System</label>
                </div>
                <input type='file' accept="application/pdf" onChange={(ev)=>{
                    let file=ev.target.files[0]
                    if(file!==undefined){
                    console.log(file)
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        // setfiledata(e.target.result)
                        // console.log(e.target.result)
                        setuploadPdfFromDesk({...uploadPdfFromDesk, pdf2:e.target.result})
                    }
                    reader.readAsDataURL(file);
                    }
                }}/>
            </div>
            <button className='btn btn-primary' onClick={mergePdfDocu}>Marge Doc</button>
        </div>
    )
}
export default PdfMerge;